import {
  doc,
  query,
  where,
  getDoc,
  addDoc,
  getDocs,
  deleteDoc,
  collection,
  DocumentData,
  WithFieldValue,
  setDoc,
} from "firebase/firestore";

import { Utils } from "utils";
import { db } from "configs/firebase";
import { CustomPlace, Iterable } from "types";

export const listCollection = collection(db, "Places");

export const list = async (countries: string[], tags: string[]) => {
  try {
    const chunks = Utils.Helpers.chunkArray(countries, 10);
    const queries = chunks.map((chunk) =>
      query(
        listCollection,
        where("country", "in", chunk),
        where("tag", "in", tags)
      )
    );

    const responses = await Promise.all(queries.map((item) => getDocs(item)));
    const places = responses.map((response) =>
      Utils.Helpers.castDocs<Iterable<CustomPlace>>(response)
    );

    return places.flat(1);
  } catch (error) {
    return Promise.reject(error);
  }
};

export const create = (data: WithFieldValue<DocumentData>) => {
  const collectionRef = collection(db, "Places");
  return addDoc(collectionRef, data);
};

export const remove = (id: string) => {
  return deleteDoc(doc(db, "Places", id));
};

export const editBoundary = (id: string, data: any) => {
  const document = doc(db, "Boundaries", id);
  return setDoc(document, data, { merge: true });
};

export const boundary = (code: string) => {
  const document = doc(db, "Boundaries", code);
  return getDoc(document);
};
